import { Box, Typography } from '@mui/material'

import { GenericDialog, MButton } from 'components'
import { color } from 'config/color'
import { useAuth } from 'context'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { isAuthorized } from 'utils'
import { UnlinkedAccountCard } from './UnlinkedAccountCard'

interface IUnlinkAccountDialog {
  linkedAccounts: any
  mainAccountNumber: string
  open: boolean
  onClose: () => void
}

export const UnlinkAccountDialog = ({
  linkedAccounts,
  mainAccountNumber,
  open,
  onClose
}: IUnlinkAccountDialog): JSX.Element => {
  const { enqueueSnackbar } = useSnackbar()
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email') ?? ''
  const navigate = useNavigate()
  const { unlinkICAccounts, handleLogOut } = useAuth()
  const [selectedAccounts, setSelectedAccounts] = useState([])
  const handleUnlinkAccounts = async (): Promise<void> => {
    try {
      await unlinkICAccounts({
        accountList: selectedAccounts,
        email
      })
      navigate(0)
    } catch (e: any) {
      if (!isAuthorized(e)) await handleLogOut()
      enqueueSnackbar(e?.message, { variant: 'error' })
      onClose()
    }
  }

  const handleSubmit = async (): Promise<void> => {
    await handleUnlinkAccounts()
  }

  return (
    <Box>
      <GenericDialog open={open} onClose={onClose}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box display="flex" flexDirection="column">
            <Typography color={color.grey[900]} fontWeight={500} fontSize={24}>
              Unlink Account
            </Typography>

            <Typography color={color.grey[700]} fontWeight={400} fontSize={16}>
              Here you can unlink one account or more. Enter the required
              information
            </Typography>
          </Box>

          <Box display="flex" flexDirection="column" gap={1}>
            <>
              {linkedAccounts.filter((la: any) => la.accountId !== mainAccountNumber).map((linkedAccount: any, index: number) => (
                <Box key={index}>
                  <UnlinkedAccountCard
                    accountId={linkedAccount.accountId}
                    serviceAddress={linkedAccount.serviceAddress}
                    selectedAccounts={selectedAccounts}
                    setSelectedAccounts={setSelectedAccounts}
                  />
                </Box>
              ))}
            </>
          </Box>

          <Box display="flex" flexDirection="column" gap={1}>
            <MButton
              type="button"
              variant="contained"
              rounded="true"
              texttransform="none"
              onClick={handleSubmit}
            >
              Unlink Account(s)
            </MButton>

            <MButton
              variant="outlined"
              type="button"
              rounded="true"
              texttransform="none"
              onClick={onClose}
            >
              Go Back
            </MButton>
          </Box>
        </Box>
      </GenericDialog>
    </Box>
  )
}
